import { render, staticRenderFns } from "./OppotunityDetail-history.vue?vue&type=template&id=0b6af2e9"
import script from "./OppotunityDetail-history.vue?vue&type=script&lang=js"
export * from "./OppotunityDetail-history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports